<template>
    <li class="c-articleCard c-blog__card" :data-id="article.id">
        <span v-if="article.category.length" class="c-articleCard__tags">
            <button class="c-btn c-articleCard__tags__tippyTrigger" :id="'tippy-' + article.id" :aria-label="tippyAriaLabel($t('blogArticle.tippy.aria'), article.title)">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M856-390 570-104q-12 12-27 18t-30 6q-15 0-30-6t-27-18L103-457q-11-11-17-25.5T80-513v-287q0-33 23.5-56.5T160-880h287q16 0 31 6.5t26 17.5l352 353q12 12 17.5 27t5.5 30q0 15-5.5 29.5T856-390ZM513-160l286-286-353-354H160v286l353 354ZM260-640q25 0 42.5-17.5T320-700q0-25-17.5-42.5T260-760q-25 0-42.5 17.5T200-700q0 25 17.5 42.5T260-640Zm220 160Z"/></svg>
            </button>
            <span style="display: none;" aria-hidden="true">
                <span class="c-articleCard__tags__tippyTip">
                    <template v-for="category of article.category">
                        <a v-if="exceptionCategory(category)" :key="category" :href="archiveUrl + '?cat%5B%5D=' + category" :aria-label="$t('blogArticle.category').replace('%s', categoriesData[category])">{{ categoriesData[category] }}</a>
                    </template>
                </span>
            </span>
            
        </span>
        <a :href="article.url" :aria-label="$t('blogArticle.link') + ' ' + article.title">
            <BaseImage
                v-if="article.image"
                :img="article.image"
                :crop="'cards_492'"
                :alt="article.image.alt || article.image.title"
                :lazyload="true"
                :modifiers="'c-article--image'"
                :role="'presentation'"
            />
            <div class="c-articleCard__infos o-wysiwyg">
                <p class="c-articleCard__label">{{ $t('blogArticle.label') }}</p>
                <h3 class="c-articleCard__title" v-html="article.title"></h3>
            </div>
        </a>
    </li>
</template>

<script>
    import BaseImage from "./BaseImage.vue";
    import tippy from 'tippy.js';

    export default {
        name: 'Card',
        components: {
            BaseImage,
            
        },
        data() {
            return {
                categoriesData: {},
            }
        },
        props: {
            article: {
                type: Object,
                default: {},
            },
            categories: {
                type: Object,
                default: {},
            },
            archiveUrl: {
                type: String,
                default: '',
            },
        },
        mounted() {
            for(const [parentCategorySlug, parentCategory] of Object.entries(this.categories)){
                this.categoriesData[parentCategorySlug] = parentCategory.title;

                if(parentCategory.children){
                    for(const [categorySlug, category] of Object.entries(parentCategory.children)){
                        this.categoriesData[categorySlug] = category.title;

                        if(category.children){
                            for(const [childCategorySlug, childCategory] of Object.entries(category.children)){
                                this.categoriesData[childCategorySlug] = childCategory.title;
                            }
                        }
                    }
                }
            }

            setTimeout(() => {
                tippy(`#tippy-${this.article.id}`, {
                    content(reference) {
                        const template = reference.nextElementSibling;
                        return template.innerHTML;
                    },
                    allowHTML: true,
                    interactive: true,
                    theme: 'tmauricie',
                    trigger: 'mouseenter click'
                });
            }, 500)

            
        },
        methods: {
            exceptionCategory(slug){
                if(slug === 'ou-manger' || slug === 'ou-dormir' || slug === 'quoi-faire'){
                    return false;
                }
                else{
                    return true;
                }
            },
            tippyAriaLabel(translation, value) {
                return translation.replace('%s', value);
            },
        }
    }
</script>